module.exports = __webpack_public_path__ + "img/Justyna Broniszewska.5bcc3b8a.jpg";